import { useCallback, useContext, useState } from "react";

import { updateLangSchemeService } from "../services/InterfaceService";
import { setLocalItem } from "../storage/LocalStorage";
import { userInfoLL } from "../storage/LocalStorageIds";
import { LangContext, UserDataContext } from "../../app/contexts/Contexts";

const normalizeLanguage = (language) =>
  String(language || "en").toLowerCase().startsWith("es") ? "es" : "en";

export function useLanguage() {
  const { lang, setLang } = useContext(LangContext);
  const { userData, setUserData } = useContext(UserDataContext);
  const [loading, setLoading] = useState(false);

  // LayoutTemplate es la unica fuente responsable de cargar /api/lang/sch.
  // Este hook solo persiste el cambio y actualiza el idioma del contexto.
  const changeLanguage = useCallback(
    async (newLang, userIdOverride) => {
      const code = normalizeLanguage(newLang);
      const currentLanguage = normalizeLanguage(lang ?? userData?.idioma);

      if (code === currentLanguage) {
        return;
      }

      setLoading(true);

      try {
        const targetUserId = userIdOverride ?? userData?.idUsuario;

        if (targetUserId) {
          await updateLangSchemeService({
            IdUsuario: targetUserId,
            Idioma: code,
          });
        }

        const updatedUser = {
          ...(userData || {}),
          ...(targetUserId && !userData?.idUsuario
            ? { idUsuario: targetUserId }
            : {}),
          idioma: code,
        };

        setUserData(updatedUser);
        setLocalItem(userInfoLL, updatedUser);
        setLocalItem("language", code);

        // Este cambio hace que LayoutTemplate cargue el esquema exactamente
        // una vez y distribuya los textos mediante UiTextsContext.
        setLang(code);
      } catch (error) {
        console.error("Error cambiando idioma:", error);
      } finally {
        setLoading(false);
      }
    },
    [lang, setLang, setUserData, userData],
  );

  return { lang, loading, changeLanguage };
}
